import { useTranslation } from "react-i18next";
import "./Card.scss";

interface CardProps {
  title?: string;
  innerCard?: boolean;
  className?: string;
  children: React.ReactNode;
}

export default function Card({
  title,
  innerCard,
  className,
  children,
}: CardProps) {
  const { t } = useTranslation();

  return (
    <div
      className={
        innerCard
          ? ""
          : "container bg-white border-bottom rounded-bottom rounded-top mb-143-rem"
      }
    >
      <div className={"card-component row " + (className ? className : "")}>
        <div className="col-sm-4">
          {title && (
            <div className="ps-096-rem pt-228-rem">
              <span className="card-title text-gray-36 font-weight-600">
                {t(title)}
              </span>
            </div>
          )}
        </div>
        <div className="col-sm-8">{children}</div>
      </div>
    </div>
  );
}
